import { AuthData } from "sharedFeatures/sharedModels";
import {LicensePackageType, LicenseFrequencyType, LicensePackageOptions } from "sharedFeatures/enums";
import { Utils } from "sharedGuiSmall/utils/utils";

export class AuthUtils {

    static noneText = <LicenseFrequencyType>$localize`None`;
    static monthlyText = <LicenseFrequencyType>$localize`Monthly`;
    static annuallyText = <LicenseFrequencyType>$localize`Annually`;

    // Does user have a beta feature
    public static isBetaFeatureActive(authData: AuthData, featureName: string): boolean {
        if (!authData.betaFeatures) return false;

        return authData.betaFeatures.indexOf(featureName) !== -1;
    }

    // Get BrixxSingle plans count (BrixxXX suffix)
    public static getBrixxPlansCount(brixxCode: string) {
        if (!brixxCode || !brixxCode.length)
            return "";

        return `with ${brixxCode.replace("Brixx", "")} plan(s)`;
    }

    public static getBrixxSinglePlansCount(brixxSingleOption: string): string {
        console.log(brixxSingleOption);
        if (brixxSingleOption == 'BrixxFree')
            return '1';

        // todo main logic
        return '0';
     }

    public static getLicensePackageNameByUniqueKey(uniqueKey: string): string { 
        let result = '';
        LicensePackageOptions.forEach((value, key) => {
            if (value.UniqueCode === uniqueKey)
                result = key;
        });
        return result;
    }

    // Get license price option PackageType
    public static getLicensePackageType(priceOptionCodes: string[]): string {        

        if (!priceOptionCodes || !priceOptionCodes.length)
            return LicensePackageType.None;
        
        let result = '';
        LicensePackageOptions.forEach((value, key) => {
            if (priceOptionCodes.indexOf(value.UniqueCode) !== -1)
                result = key;
        });

        if (result != '')
            return result;
         
        if (priceOptionCodes.filter(x => x.includes('Brixx')).length) {
            return LicensePackageType.BrixxSingle;
        }        
        
        return LicensePackageType.None;
    }

    // Get license price option Frequency
    public static getLicenseFrequency(priceOptionCodes: string[]): LicenseFrequencyType {
        if (!priceOptionCodes || !priceOptionCodes.length)
            return this.noneText;

        if (priceOptionCodes.indexOf('BrixxFree') !== -1) {
            return this.monthlyText;
        }
        else if (priceOptionCodes.indexOf('Monthly') !== -1) {
            return this.monthlyText;
        }
        else if (priceOptionCodes.indexOf('Annually') !== -1) {
            return this.annuallyText;
        }

        return this.noneText;
    }

}
